import { Layouts } from 'react-grid-layout';

export const layoutConfig: Layouts | undefined = {
    lg: [
        {
            h: 3,
            static: true,
            w: 24,
            x: 0,
            y: 1,
            i: 'c2',
        },
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
    ],
    md: [
        {
            h: 3,
            static: true,
            w: 24,
            x: 0,
            y: 1,
            i: 'c2',
        },
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
    ],
    xs: [
        {
            h: 3,
            static: true,
            w: 24,
            x: 0,
            y: 2,
            i: 'c2',
        },
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
    ],
};
export const pageConfig: PageConfig = {
    pageProps: {},
    components: [
        {
            key: 'c1',
            name: 'page-header',
            props: {
                header: {
                    title: 'ui.analytics.customer-workbooks',
                    path: '',
                },
                rhsComponents: [],
            },
        },
        {
            name: 'customer-workbook-wrapper',
            key: 'c2',
            props: {},
            fromStore: [{ key: 'appData', value: 'menuStructure' }],
        },
    ],
};
